import jwt_decode from 'jwt-decode';
import moment from 'moment';
import { API_TYPES } from '../constants/APIDirectoryConstants';
import { RESOURCE_TYPES } from '../constants/constants';
const _ = require('lodash');

const OKTA_TOKEN_STORAGE = 'okta-token-storage';

// Define constants for statuses
const STATUS_ACTIVE = "active";
const STATUS_PENDING = "pending";
const CERTIFICATION_STATUS_CERTIFIED = "certified";

export function hasIntegrationCertified(integrations=[{}]) {
  for (const integration of integrations) {
    if (integration.status === STATUS_ACTIVE && integration.certificationStatus === CERTIFICATION_STATUS_CERTIFIED) {
      return true;
    }
  }
  
  for (const integration of integrations) {
    if (integration.status === STATUS_PENDING && integration.certificationStatus === CERTIFICATION_STATUS_CERTIFIED) {
      return true;
    }
  }
  
  return false;
}

export function hasPendingCertifiedApi(apis=[]) {
  for (const api of apis) {
    if(!hasIntegrationCertified(api?.integrations)){
       return true;
    }
  }
  
  return false;
}



export const modifyStr = str => {
    let length = str && str.length;
    let modifiedStr = '';
    for(var i = 0; i < length; i++) {
      let prevChar = i === 0 ? '' : str.charAt(i-1);
      let currChar = str.charAt(i);
      if(prevChar !== '-') {
        modifiedStr += currChar;
      } else if(currChar !== '-') {
        modifiedStr += currChar;
      }
    }

    let modifiedStrLength = modifiedStr.length;
    //remove trailing hypen
    if(modifiedStr.charAt(modifiedStrLength - 1) === '-') {
      modifiedStr = modifiedStr.substring(0, modifiedStrLength - 1);
    } 

    return modifiedStr;
}

const validateField = (str, re = /./, canBeEmpty = false) => {
  if (validateNotEmpty(str)) {
    return re.test(str.trim());
  }
  return canBeEmpty;
};

const validateNotEmpty = (str) => {
  const val = str && str.trim();
  if (val && val.length) {
    return true;
  }
  return false;
};

export const validateUrl = (
  value,
  { https = false, localhost = false, canBeEmpty = false } = {}
) => {
  let re;
  if (https) {
    if (localhost) {
      re =
        /^(https:\/\/)?(www)?[a-z0-9]+([-.]{1}[a-z0-9]+)*((\.[a-z]{2,63})|(:[0-9]{1,5}))(\/.*)?$/;
    } else {
      re =
        /^https:\/\/(www)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,5})?(\/.*)?$/;
    }
  } else {
    if (localhost) {
      re =
        /^((http|https):\/\/)?(www)?[a-z0-9]+([-.]{1}[a-z0-9]+)*((\.[a-z]{2,63})|(:[0-9]{1,5}))(\/.*)?$/;
    } else {
      re =
        /^(http|https):\/\/(www)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,5})?(\/.*)?$/;
    }
  }
  return validateField(value, re, canBeEmpty);
};

export const isTokenValid = () => {  
  const localToken = getLocalToken();

  if(isTokenEmpty(localToken)) {
    return false;
  }

  const decodedToken = jwt_decode(localToken);
  
  return decodedToken?.exp * 1000 > Date.now();
}

export const clearSessionAndReload = () => {
  const token = getLocalToken();

  if(!isTokenEmpty(token)) {
    removeLocalToken();
    window.location.reload();
  }
}
const parseDocKeyFromUrl = url => {
  const urlParts = url.split('/');
  const parsedKey =
    urlParts.length > 5
      ? `${[urlParts[3], urlParts[4]].join('/')}/${urlParts[5].split('?')[0]}`
      : '';
  return parsedKey;
};

export const getConsentPayload = async (
  auth = {},
  api = {},
  solutionOrgId,
  acceptedPricePlanId
) => {
  const isAsyncApi = api.kind === API_TYPES.ASYNC
  const terms = api.terms[0];

  let apiId = api.id;
  let providerId = api.id;

  let payload = {
    listingVersion: '1',
    reasonForRejection: '',
    consentType: 'api_tos',
    organizationId: solutionOrgId,
    api: isAsyncApi ? apiId : `${API_TYPES.PROVIDER_ID_PREFIX}-${apiId}`,
    apiProviderId: isAsyncApi ? apiId : `${API_TYPES.PROVIDER_ID_PREFIX}-${providerId}`,
    signedTermsAndConditions: terms.url,
    signedTermsAndConditionsS3: terms.url,
    status: 'accepted',
    documentLink: terms.url,
    subscriptionStatus: 'new',
    // acceptedCompany: api?.file?.consentCompany,
    // acceptedName: api?.file?.consentName,
    // acceptedTitle: api?.file?.consentTitle,
    consentedSource: 'dp',
    name: auth.userData?.name,
    userEmail: auth.userData?.email,
    asyncApiTermsDocKey:
      isAsyncApi && terms.url ? parseDocKeyFromUrl(terms.url) : undefined,
    acceptedPricePlanId: acceptedPricePlanId
  };

  return payload;
};
export const isTokenEmpty = localToken => !localToken || localToken === '{}';

export const getLocalToken = () => localStorage.getItem(OKTA_TOKEN_STORAGE);

const removeLocalToken = () => localStorage.removeItem(OKTA_TOKEN_STORAGE);

// lodash’s isEqual considers array element order, adjustment to ignore order changes
export const isEqualIgnoreOrder = (obj1, obj2) => {
  const sortArrays = (value) => {
    if (Array.isArray(value)) {
      return [...value].sort();
    } else if (typeof value === 'object' && value !== null) {
      return Object.keys(value).reduce((sortedObj, key) => {
        sortedObj[key] = sortArrays(value[key]);
        return sortedObj;
      }, {});
    }
    return value;
  };

  return _.isEqual(sortArrays(obj1), sortArrays(obj2));
}

export const getMatchingResources = (
  resource,
  apisObject = {},
  asyncApisObject = {},
  bundlesObject = {}
) => {
  if (!resource) {
    return {};
  }

  const resourceType = resource.resourceType || resource.apiType;
  const resourceId = resource.resourceId || resource.apiId;

  if (!resourceType || !resourceId) {
    return {};
  }

  switch (resourceType) {
    case RESOURCE_TYPES.ASYNC_API:
      return asyncApisObject[resourceId] || {};

    case RESOURCE_TYPES.API:
      return apisObject[resourceId] || {};

    case RESOURCE_TYPES.BUNDLE:
      return bundlesObject[resourceId] || {};

    default:
      return {};
  }
};

export function toDateStringFormat(time) {
  return time === -1 ? '' : moment(time).format('MMMM D, YYYY');
}

export const triggerUserDownload = (filename = 'file', data) => {
  if (typeof data === 'object') {
    data = JSON.stringify(data, null, '\t');
  }
  const blob = new Blob([data]);
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(blob);
};

 export const getInstanceIdVersionMap = apiInfo => {
  const specEnv = apiInfo?.environments?.find(f => f.name === 'prod');
  let spec = [];
  if (!!specEnv?.instances && Array.isArray(specEnv.instances)) {
    specEnv.instances.forEach(f => {
      spec = [
        ...spec,
        {
          apiInstanceId: f.id,
          version: f.version
        }
      ];
    });
  }
  return spec;
};

// Deep equality check using lodash
export const deepEqual = (obj1, obj2) => {
  return _.isEqual(obj1, obj2);
};